module.exports = ol.extent;